import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Eye, EyeOff } from 'lucide-react';
import { ToastMessage, ToastTypes } from './ToastMessage'; // Adjust import path as needed
import { login as loginAPI } from "../services/authService"; // Renamed the API function
import { REFRESH_TOKEN, ACCESS_TOKEN, EMAIL } from "../components/constants";
function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [toast, setToast] = useState(null);
  const { login } = useAuth(); // Use the context login function to set the authenticated user
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { token, user } = await loginAPI(email, password); // Call the backend API
      localStorage.setItem(ACCESS_TOKEN, token); // Save JWT token
      localStorage.setItem(EMAIL, email);
      login(user); // Update user in AuthContext
      setToast({
        message: "Login Successful! Redirecting to Dashboard...",
        type: ToastTypes.SUCCESS,
      });
      setTimeout(() => navigate("/dashboard"), 2000); // Redirect to dashboard
    } catch (error) {
      setToast({
        message: error.message || "Invalid credentials. Please try again.",
        type: ToastTypes.ERROR,
      });
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex justify-center items-center px-4">
      {toast && (
        <ToastMessage
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
      <div className="w-full max-w-md p-10 bg-white rounded-xl shadow-2xl border border-gray-200">
        <h1 className="text-4xl font-['Poppins'] font-bold text-center text-blue-900 mb-6">
          SPL AUTOMATION
        </h1>
        <h2 className="text-xl font-semibold text-gray-600 text-center mb-6">
          Welcome Back!
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-5">
            <label
              htmlFor="email"
              className="block text-gray-700 font-medium mb-2"
            >
              Email Address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
              required
            />
          </div>
          <div className="mb-6 relative">
            <label
              htmlFor="password"
              className="block text-gray-700 font-medium mb-2"
            >
              Password
            </label>
            <div className="relative">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                required
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 focus:outline-none"
              >
                {showPassword ? (
                  <EyeOff size={20} />
                ) : (
                  <Eye size={20} />
                )}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-900 text-white py-3 rounded-lg hover:bg-blue-800 transition duration-300 ease-in-out transform hover:scale-[1.02] shadow-md"
          >
            Login
          </button>
        </form>
        <div className="text-center mt-6">
          <p className="text-gray-600">
            Don't have an account?{" "}
            <span
              className="text-blue-900 hover:underline cursor-pointer font-semibold"
              onClick={() => navigate("/signup")}
            >
              Sign Up
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
